module.exports = __webpack_public_path__ + "img/portrait.50045ed4.png";